import React, { PropTypes } from 'react';
import { ListGroup, ListGroupItem } from 'react-bootstrap';

class ShopSubCategoryList extends React.Component {
   render() {
      const { subCategories } = this.props;
      return (
         <ListGroup>
            {subCategories.map((subCategory) => (
               <ListGroupItem key={subCategory.id} >
                  {subCategory.name}
               </ListGroupItem>
            ))}
         </ListGroup>
      );
   }
}

ShopSubCategoryList.propTypes = {
   subCategories: PropTypes.array.isRequired
};
export default ShopSubCategoryList;



/** WEBPACK FOOTER **
 ** ./src/components/ShopManagement/Shop/ShopSubCategoryList.js
 **/